// extracted by mini-css-extract-plugin
export var promotionLink = "_we-0";